import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { Edit } from "@components/modules/invoices/Create";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { RequestForInvoicingNavigation } from "@src/components/widgets/AppSubNav/navigation-invoices/requests-for-invoicing";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Edit invoice`}
    navigation={<RequestForInvoicingNavigation invoiceId={id} />}
  >
    <Edit.RequestForInvoice id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/for-invoicing/edit")({
  component: RouteComponent,
});
